// extracted by mini-css-extract-plugin
module.exports = {"cardsWrapper":"KeyBenefitsSection_cardsWrapper__1E4C_","buttonWrapper":"KeyBenefitsSection_buttonWrapper__1hMSH"};